import NoSSR from '@components/NoSSR'
import {useWebsiteMenuInformation} from '@data/queries/website/websiteMenuInformation.main'
import useCategoriesCPG from '@hooks/useCategoriesCPG.main'
import {useRef} from '@hooks/useRef'
import useShouldHidePrice from '@hooks/useShouldHidePrice'
import useState from '@hooks/useState'
import useWebsiteId from '@hooks/useWebsiteId'
import Container from '@packages/justo-parts/lib/components/Container'
import Bar from '@page-components/Order/Products/ProductsContent/Bar'
import {useRouter} from 'next/router'

import NextOpenDateWrapper from '../NextOpenDate'
import Filters from '../Products/ProductsContent/Filters'
import useLayout from '../useLayout'

import Categories from './Categories'
import CategoriesBar from './CategoriesBar'
import ProductSelected from './ProductSelected'
import SearchResults from './SearchResults'

import StoreName from '@page-components/CheckoutV3/legacyCode/StoreName'
import styles from './styles.module.css'

export default function LongOrCompactCPG() {
  const {website} = useWebsiteMenuInformation()
  const layout = useLayout()

  const websiteId = useWebsiteId()
  const router = useRouter()
  const [filter, setFilter] = useState('')
  const [sorting, setSorting] = useState(null)
  const shouldHidePrice = useShouldHidePrice()
  const {productId} = router.query

  const {categoriesCPG} = useCategoriesCPG({websiteId})
  const categoryRef = useRef([])

  const scrollToCategory = categoryId =>
    setTimeout(
      () =>
        categoryRef.current[categoryId].scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        }),
      100,
    )

  return (
    <div className={`${styles.container} ${styles[`container_${layout}`]}`}>
      <NoSSR>
        <Bar
          filter={filter}
          setFilter={filter => {
            setFilter(filter)
          }}
        >
          <CategoriesBar
            categories={categoriesCPG}
            website={website}
            setFilter={setFilter}
            scrollToCategory={scrollToCategory}
            categoryRefs={categoryRef}
          />
        </Bar>
      </NoSSR>
      <Container className={styles.containerLabel}>
        <div className={styles.containerIcon}>
          <StoreName isOnMenu />
        </div>
        <div className={styles.containerFilter}>
          <NoSSR>
            <Filters sorting={sorting} setSorting={sorting => setSorting(sorting)} />
          </NoSSR>
        </div>
      </Container>
      <Container>
        {filter ? (
          <SearchResults filter={filter} shouldHidePrice={shouldHidePrice} />
        ) : (
          <>
            <NextOpenDateWrapper />
            <br />
            <Categories
              categories={categoriesCPG}
              categoryRef={categoryRef}
              sorting={sorting}
              shouldHidePrice={shouldHidePrice}
            />
          </>
        )}
      </Container>
      <ProductSelected productId={Array.isArray(productId) ? productId[0] : productId} />
    </div>
  )
}
